import { parseISO } from 'date-fns/esm';

import { formatISO } from './formatDate';
import { cabinTypeEnum } from '../api';

export type BaseDetailParams = {
  journeyIdentifier: string;
  tariffCode: string;
  startDate: Date;
  cabinCode: string;
  adults: number;
  children: number;
  cabinType: cabinTypeEnum;
  listIndex: number;
};
type DetailParamsWithFlights = BaseDetailParams & {
  departureAirportCode: string;
  arrivalAirportCode: string;
};

export type DetailParams = BaseDetailParams | DetailParamsWithFlights;

export function isDetailParamsWithFlights(
  params: DetailParams,
): params is DetailParamsWithFlights {
  return Boolean(
    (params as DetailParamsWithFlights).departureAirportCode &&
    (params as DetailParamsWithFlights).arrivalAirportCode,
  );
}

const SEPARATOR = '~';

export function serializeDetailParams(cabinId: DetailParams) {
  if (isDetailParamsWithFlights(cabinId)) {
    const {
      journeyIdentifier,
      listIndex,
      tariffCode,
      cabinCode,
      cabinType,
      adults,
      children,
      departureAirportCode,
      arrivalAirportCode,
      startDate,
    } = cabinId;
    return encodeURIComponent(
      [
        journeyIdentifier,
        formatISO(startDate),
        tariffCode,
        cabinType,
        cabinCode,
        adults,
        children,
        departureAirportCode,
        arrivalAirportCode,
        listIndex,
      ].join(SEPARATOR),
    );
  }

  const {
    journeyIdentifier,
    listIndex,
    tariffCode,
    cabinType,
    cabinCode,
    startDate,
    adults,
    children,
  } = cabinId;
  return encodeURIComponent(
    [
      journeyIdentifier,
      formatISO(startDate),
      tariffCode,
      cabinType,
      cabinCode,
      adults,
      children,
      listIndex,
    ].join(SEPARATOR),
  );
}

export function parseDetailParams(cabinId: string): DetailParams {
  const parts = decodeURIComponent(cabinId).split(SEPARATOR);
  if (parts.length === 8) {
    return {
      journeyIdentifier: parts[0],
      startDate: parseISO(parts[1]),
      tariffCode: parts[2],
      cabinType: parts[3] as cabinTypeEnum,
      cabinCode: parts[4],
      adults: parseInt(parts[5], 10),
      children: parseInt(parts[6], 10),
      listIndex: parseInt(parts[7]),
    };
  } else if (parts.length === 10) {
    return {
      journeyIdentifier: parts[0],
      startDate: parseISO(parts[1]),
      tariffCode: parts[2],
      cabinType: parts[3] as cabinTypeEnum,
      cabinCode: parts[4],
      adults: parseInt(parts[5], 10),
      children: parseInt(parts[6], 10),
      departureAirportCode: parts[7],
      arrivalAirportCode: parts[8],
      listIndex: parseInt(parts[9]),
    };
  }
  throw new Error(`Invalid cabinId: "${cabinId}"`);
}
